












import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";

const Subscriptions = namespace("subscriptions");
const Activation = namespace("activation");

@Component({})
export default class Quota extends Vue {
  @Subscriptions.Getter("getVerificationQuota") verificationQuota: number;
  @Subscriptions.Getter("getVerificationUsedQuota")
  verificationUsedQuota: number;
  @Subscriptions.Action("getCurrentVendorQuota")
  getCurrentVendorQuota!: () => Promise<{
    billingContactName: string;
  }>;
  @Activation.Action("setBillingContactName") setBillingContactName!: (
    billingContactName: string
  ) => void;

  async beforeMount() {
    const result = await this.getCurrentVendorQuota();
    this.setBillingContactName(result.billingContactName);
  }
}
